module.exports = "https://static.wmbcdn.com/uniweb/images/dc49a0b35be5a3e87d7d1aaecae1f7ba.svg";